export default __webpack_public_path__ + "static/media/crystal.37871064.png";